import React from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const Navbar = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  if (!user || !user.acceptedTerms) return null;

  const isActive = (path) => location.pathname === path ? 'active' : '';

  return (
    <nav className="navbar">
      <div className="navbar-brand">
        <Link to="/targets">OldProject</Link>
      </div>
      <div className="navbar-menu">
        <Link to="/targets" className={isActive('/targets')}>
          Persone
        </Link>
        <Link to="/proposals/my" className={isActive('/proposals/my')}>
          Le mie proposte
        </Link>
        <Link to="/proposals/public" className={isActive('/proposals/public')}>
          Proposte pubbliche
        </Link>
        <Link to="/goals" className={isActive('/goals')}>
          Obiettivi
        </Link>
        <Link to="/profile" className={isActive('/profile')}>
          Profilo
        </Link>
        {user.isAdmin && (
          <Link to="/admin" className={isActive('/admin')}>
            Admin
          </Link>
        )}
      </div>
      <div className="navbar-user">
        <span>{user.username}</span>
        <button onClick={handleLogout} className="btn-logout">
          Esci
        </button>
      </div>
    </nav>
  );
};

export default Navbar;
